module.exports = __webpack_public_path__ + "img/Email Assist.39546c3a.png";